module.exports = __webpack_public_path__ + "static/media/NUTRTION-icon.ef6bc743.jpg";